import { render, staticRenderFns } from "./TagReveal.vue?vue&type=template&id=c933f476&scoped=true&"
import script from "./TagReveal.vue?vue&type=script&lang=js&"
export * from "./TagReveal.vue?vue&type=script&lang=js&"
import style0 from "./TagReveal.vue?vue&type=style&index=0&id=c933f476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c933f476",
  null
  
)

export default component.exports